import { CanDeactivateFn } from '@angular/router';
import type { ConvertirComponent } from './convertir.component';

export const convertirCanDeactivate: CanDeactivateFn<ConvertirComponent> = (component) => {
  return component.confirmarSalidaSiDatosPendientes();
};
